export enum sectionTypes {
  SEPARATOR = 'Separator',
  CONTENT = 'Content',
}

export enum scoreBasis {
  SEPARATOR = 0,
  TOTAL = 1,
  DIMENSION = 2,
}

export enum Flow {
  STOP = 'stop',
  PAUSE = 'pause',
  PLAY = 'play',
  COMPLETE = 'complete',
}

export enum FieldTypes {
  Date = 'Date',
  DateTime = 'DateTime',
  Text = 'Text',
  Checkbox = 'Checkbox',
  Number = 'Number',
  Amount = 'Amount',
  Dropdown = 'Dropdown',
  LongText = 'LongText',
  Notes = 'Notes',
  Email = 'Email',
  File = 'File',
  Percentage = 'Percentage',
  Phone = 'Phone',
  Signature = 'Signature',
  Formula = 'Formula',
}

export enum ViewMode {
  FUNNEL = 'funnel',
  DOC = 'doc',
  DEFAULT = 'default',
}

export enum Integration {
  Community = 'community',
  Salesforce = 'salesforce',
  SmartWe = 'smartwe',
  HubSpot = 'hubspot',
  MicrosoftDynamics = 'msdynamics',
}
export enum AssessmentType {
  MULTI = 'multi select',
  SINGLE = 'single select',
}
export enum ConditionalRule {
  OR = 'OR',
  AND = 'AND',
  None = 'None',
}

export enum ScoreMode {
  ENTIRE = 'Entire',
  COVERED = 'Covered',
}

export enum QuestionTypes {
  DATE = 'Date',
  DATE_TIME = 'DateTime',
  PERCENTAGE = 'Percentage',
  TEXT = 'Text',
  CHECKBOX = 'Checkbox',
  NUMBER = 'Number',
  AMOUNT = 'Amount',
  DROPDOWN = 'Dropdown',
  LONG_TEXT = 'LongText',
  EMAIL = 'Email',
  FILE = 'File',
  PHONE = 'Phone',
  SIGNATURE = 'Signature',
  NOTES = 'Notes',
  FORMULA = 'Formula',
}
/**
 * Enum for the types of widgets that can be incorporated into various places of the Action Card.
 * @story User Story 8109: Productize AI-supported sections
 */
export enum WidgetType {
  GenericAiPrompt = 'GenericAiPrompt',
  TextToSpeech = 'TextToSpeech',
  UpdateWithAi = 'UpdateWithAi',
  CreateCrmObject = 'CreateCrmObject',
  CodeSnippet = 'CodeSnippet',
  SetTag = 'SetTag',
  ConnectToCrm = 'ConnectToCrm',
  RecommendPlaybooks = 'RecommendPlaybooks',
  AiTeammate = 'AiTeammate',
}
/**
 * Enum for the output modes of the AI widgets (where to display the generated text).
 * @story User Story 10482: Generic Prompt AI widget: select output mode: add or replace
 */
export enum WidgetOutputMode {
  /** Append the generated text under the widget */
  Add = 'Add',
  /** Replace the recommendation text with the generated text (#10482) */
  Replace = 'Replace',
}

/**
 * Enum for the types of object state.
 */
export enum ObjectStateType {
  IsCrmObjectCreated = 'IsCrmObjectCreated',
  IsTagSet = 'IsTagSet',
}

export enum ElementKind {
  ASSESSMENT = 'Assessment',
  RECOMMENDATION = 'Recommendation',
  QUESTION = 'Question',
  WIDGET = 'Widget',
}

export enum ObjectTypes {
  Contact = 'Contact',
  Company = 'Company',
  Opportunity = 'Opportunity',
}
